// extracted by mini-css-extract-plugin
export default {"message-file-tag":"styles_message-file-tag__6NZYd","icon":"styles_icon__0g++0"};